import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_AllMessengers, putAPI_Messengers_CopyTemplate } from '../../../../../../constants/APIs';
import MessengerThumbListView from './MessengerThumbListView';

const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;
export function TemplateMessengerList({
    visible,
    toggle,
    formLabel,
    LoadData,
    propertyId,
    allAddonCategoryData,
    locale
}) {
    const [servicesData, setservicesData] = useState([]);
    const [selectedItems, setselectedItems] = useState([]);
    const [lastChecked, setlastChecked] = useState(null);
    useEffect(() => {
        let data = {
            groupId: fromGroupId,
            languageCode: "en",
            propertyId: [fromPropertyId]
        };
        AxiosAPI({
            method: 'post',
            url: `${gAPI_AllMessengers}`,
            data: data
        }).then((res) => {
            let service = res.data.messengers.filter(x => x.status === "Active").sort((a, b) => a.displayOrder - b.displayOrder);
            setservicesData(service);
        })
            .catch((err) => console.log('err', err));
    }, [allAddonCategoryData]);

    const handleSubmit = () => {
        var data = {
            ToGroupId: getGroupID(),
            ToPropertyId: propertyId,
            FromGroupId: fromGroupId,
            FromPropertyId: fromPropertyId,
            Id: selectedItems
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Messengers_CopyTemplate}`,
            data: data
        }).then((res) => { LoadData(locale); toggle(); });
    };

    const onCheckItem = (event, id) => {
        if (
            event.target.tagName === "A" ||
            (event.target.parentElement && event.target.parentElement.tagName === "A")
        ) {
            return true;
        }
        if (lastChecked === null) {
            setlastChecked({ lastChecked: id })
        }

        let selitems = selectedItems;
        if (selitems.includes(id)) {
            selitems = selitems.filter(x => x !== id);
        } else {
            selitems.push(id);
        }
        setselectedItems([...selitems])
        document.activeElement.blur();
    };

    const handleChangeSelectAll = isToggle => {
        if (selectedItems.length >= servicesData.length) {
            if (isToggle) {
                setselectedItems([])
            }
        } else {
            let selitems = []
            servicesData.map(x => selitems.push(x.id))
            setselectedItems([...selitems])
        }
        document.activeElement.blur();
        return false;
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    <h4><b> Web Widget Menus Templates</b> </h4>
                    <p>  You'll find templates of commonly used Web Widget Menus below, ready for your business to use.</p>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx xxs="12">
                            <div className="mb-2">
                                <div className="text-zero">
                                    <div className="pr-0 check-button check-all">
                                        <CustomInput
                                            className="custom-checkbox mb-0 d-inline-block"
                                            type="checkbox"
                                            id="checkAll"
                                            checked={selectedItems.length >= servicesData.length}
                                            onChange={() => handleChangeSelectAll(true)}
                                            label="Select All"
                                        />
                                    </div>
                                </div> </div>
                        </Colxx>
                    </Row>
                    <Row>
                        {servicesData !== undefined && servicesData !== null && servicesData.length > 0 && servicesData.map(service => {
                            return (
                                <MessengerThumbListView
                                    key={service.id}
                                    service={service}
                                    isSelect={selectedItems.includes(service.id)}
                                    onCheckItem={onCheckItem}
                                    allAddonCategoryData={allAddonCategoryData}
                                />
                            );
                        })}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {/* <p> These will be added with inactive status, you can edit and make them active when you ready </p> */}
                    <Button color="primary" onClick={handleSubmit}>
                        Add Selected
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>)
};